const state = {
    purchaseinvoices: [],
    purchaseinvoiceId: [],
    loading: false,

    documents: [],
    file: null,
    docLoader: false,
};

export default state;